// Single source of truth for brand assets
export const BRAND_LOGO = 'https://customer-assets.emergentagent.com/job_8d33ea52-c764-4e32-b8e2-de0e8040a6fa/artifacts/ixkpli1q_aiSchool%20%281%29.png';
export const BRAND_LOGO_ALT = 'aiSchool for All';
export const WHATSAPP_NUMBER = '919891550666';
export const WHATSAPP_URL = (msg = 'Hi, I want to know more about your courses') =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
